// import { initCharitySearch } from "../../charity-projects-search";
import I18n from "../../../translations/i18n";

export function initGlobalGiving() {
  if ($(".global-giving-redeem-container").length == 0) {
    return;
  }
  // initCharitySearch();
  selectCauseListener();
  globalGivingFormErrorMessageListener();
  searchRadioSelectedListener();
}

export function selectCauseListener() {
  $(document).on("focus", "#redemption_project_name", function () {
    $("#redemption_donation_type_project_name").trigger("click");
  });
}

export function globalGivingFormErrorMessageListener() {
  var requiredFields = $(".redemption-info-form input:required");

  requiredFields.each(function (index, element) {
    var redemption = $(element)[0];
    var redemptionError = $(element)
      .closest(".error-wrapper")
      .find("span.error")[0];
    var redemptionErrorText = $(element)
      .closest(".error-wrapper")
      .find("span.error .error-text")[0];

    redemption.addEventListener("change", function (event) {
      redemptionErrorText.innerHTML = ""; // Reset the content of the message
      if (!redemption.validity.valid) {
        $(".global-giving-redeem-container .confirm-redemption-btn")
          .addClass("disabled-btn")
          .removeClass("primary-btn");
        showGlobalGivingError(redemption, redemptionErrorText, redemptionError);
        event.preventDefault();
      } else {
        checkAllValid();
        redemptionError.className = "error";
      }
    });
  });
}

export function searchRadioSelectedListener() {
  $(
    "#redemption_donation_type_monthly, #redemption_donation_type_project_name"
  ).on("click", function () {
    if ($("#redemption_donation_type_project_name")[0].checked) {
      $("#redemption_project_name").prop("required", true);
      checkAllValid();
    } else {
      $("#redemption_project_name").prop("required", false);
    }
  });
}

export function showGlobalGivingError(
  redemption,
  redemptionErrorText,
  redemptionError
) {
  var currencySymbol = redemption.getAttribute("data-currency-symbol");
  var minAmount = redemption.getAttribute("data-currency-symbol");
  if (
    redemption.validity.rangeOverflow &&
    parseFloat(redemption.max) <=
      parseFloat(redemption.getAttribute("absolute_max"))
  ) {
    redemptionErrorText.textContent = I18n.t(
      "views.dashboards.cash_for_a_cause_page.form.errors_1.text_3"
    );
  } else if (redemption.validity.rangeUnderflow) {
    redemptionErrorText.textContent = I18n.t(
      "views.dashboards.cash_for_a_cause_page.form.errors_1.text_2",
      { min_amount: minAmount }
    );
  } else if (redemption.validity.valueMissing) {
    redemptionErrorText.textContent = I18n.t(
      "views.dashboards.cash_for_a_cause_page.form.errors_1.text_1"
    );
  } else if (redemption.validity.typeMismatch) {
    redemptionErrorText.textContent = I18n.t(
      "views.dashboards.cash_for_a_cause_page.form.errors_4.text_1"
    );
  }

  // Set the styling appropriately
  redemptionError.className = "error active";
  checkAllValid();
}

export function checkAllValid() {
  // Check to see if everything is filled in
  var numberValid = 0;
  var requiredFields = $(".redemption-info-form input:required");
  requiredFields.each(function (index, element) {
    var redemption = $(element)[0];
    if (redemption.validity.valid) {
      numberValid += 1;
    }
  });

  if (numberValid == $(".redemption-info-form input:required").length) {
    $(".global-giving-redeem-container .confirm-redemption-btn")
      .addClass("primary-btn")
      .removeClass("disabled-btn");
  } else {
    $(".global-giving-redeem-container .confirm-redemption-btn")
      .removeClass("primary-btn")
      .addClass("disabled-btn");
  }
}
